<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="addNew"
      >
        新增大区
      </a-button>

      <a-form :form="pageSearchForm">
        <a-form-item :style="{ float: 'right' }">
          <a-select
            v-decorator="[
              'company_id',
              {
                initialValue: searchArgs.company_id,
              },
            ]"
            class="activity-config-search"
            :style="{
              marginTop: '19px',
              width: '300px',
              marginRight: '20px',
            }"
            :loading="loadingSearchCompany"
            placeholder="请选择企业"
            @change="handleChangeCompany"
          >
            <a-select-option
              v-for="item in searchArgs.company_list"
              :key="item.id"
              :title="
                item.team_name ? item.team_name : item.companyInfo.qichacha_name
              "
            >
              {{
                item.team_name ? item.team_name : item.companyInfo.qichacha_name
              }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :style="{ float: 'right' }">
          <a-select
            v-decorator="[
              'platform_type',
              {
                initialValue: searchArgs.platform_type,
              },
            ]"
            class="activity-config-search"
            :style="{
              marginTop: '19px',
              width: '120px',
              marginRight: '20px',
            }"
            :loading="loadingSearchCompany"
            placeholder="请选择平台"
            @change="handleChangePlatform"
          >
            <a-select-option key="cp" value="cp">
              药企端
            </a-select-option>
            <a-select-option key="sp" value="sp">
              服务商端
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div class="global-table-container">
      <a-table
        :pagination="showPagination"
        :columns="tableColumns"
        :data-source="tableDataList"
        :row-selection="rowSelection"
        :scroll="{ x: 900, y: 450 }"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            v-if="!record.status"
            type="primary"
            shape="round"
            size="small"
            @click.stop="handleSetStatus(record, 1)"
          >
            启用
          </a-button>
          <a-button
            v-if="record.status"
            type="dashed"
            shape="round"
            size="small"
            @click.stop="handleSetStatus(record, 0)"
          >
            禁用
          </a-button>

          <a-button
            type="dashed"
            shape="circle"
            title="添加子大区"
            size="small"
            @click.stop="handleAddSub(record)"
          >
            子
          </a-button>
          <a-button
            size="small"
            type="primary"
            shape="circle"
            icon="eye"
            title="查看大区详情"
          />
          <a-button
            size="small"
            title="修改大区"
            type="primary"
            shape="circle"
            icon="edit"
            @click.stop="handleEdit(record)"
          />
          <!-- 
          <a-button
            size="small"
            title="删除大区"
            type="danger"
            shape="circle"
            icon="delete"
          />
          -->
        </div>
      </a-table>
    </div>
  </div>
</template>
<script>
import updatePanel from "@/views/System/area/update.vue";

var num = 0;
var pageContext;
export default {
  name: "AreaList",
  data() {
    return {
      showPagination: false,
      pageSearchForm: this.$form.createForm(this),
      loadingSearchCompany: false,
      // 检索参数
      company_label: "药企",
      searchArgs: {
        platform_type: "cp", // 选择平台
        company_id: "", // 选择企业
        company_list: [], // 当前选择企业列表
      },
      tableColumns: [],
      tableDataList: [],
      rowSelection: {
        fixed: true,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(selectedRowKeys);
        },
      },
    };
  },
  mounted() {
    pageContext = this;
    pageContext.initColumns();
    pageContext.handleChangePlatform("cp");
  },
  methods: {
    initColumns() {
      pageContext.tableColumns = [
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "180px",
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: "100px",
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 230,
          scopedSlots: { customRender: "action" },
        },
      ];
    },
    async handleChangePlatform(value) {
      pageContext.searchArgs.platform_type = value;
      pageContext.company_label = value === "cp" ? "药企" : "服务商";
      pageContext.searchArgs.company_list = [];
      pageContext.searchArgs.company_id = "";
      pageContext.pageSearchForm.setFieldsValue({
        company_id: pageContext.searchArgs.company_id,
      });
      pageContext.tableDataList = [];
      pageContext.loadingSearchCompany = true;
      pageContext.$http
        .post(
          value === "cp"
            ? "/company/getCompanyList"
            : "/ServiceProvider/getCompanyList",
          {
            sign_flag: 1,
            status: 1,
          }
        )
        .then(function(response) {
          if (
            response.data.status === 1 &&
            response.data.data.data_list.length > 0
          ) {
            pageContext.$message.success(
              "请选择：" + pageContext.company_label
            );
            pageContext.searchArgs.company_list = response.data.data.data_list;
            pageContext.searchArgs.company_id =
              pageContext.searchArgs.company_list[0].id;
            pageContext.pageSearchForm.setFieldsValue({
              company_id: pageContext.searchArgs.company_id,
            });
            pageContext.handleChangeCompany(pageContext.searchArgs.company_id);
          }

          pageContext.loadingSearchCompany = false;
        })
        .catch(function(error) {
          pageContext.loadingSearchCompany = false;
          console.log(error);
        });
    },
    async handleChangeCompany(value) {
      pageContext.searchArgs.company_id = value;
      pageContext.loadingSearchCompany = true;
      pageContext.tableDataList = [];
      pageContext.refreshDataList();
    },
    async refreshDataList() {
      pageContext.$http
        .post("/area/getDataList", {
          platform_type: pageContext.searchArgs.platform_type,
          company_id: pageContext.searchArgs.company_id,
        })
        .then(function(response) {
          if (
            response.data.status === 1 &&
            response.data.data.data_list.length > 0
          ) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    addNew() {
      if (pageContext.searchArgs.company_id === "") {
        pageContext.$message.info("请选择：" + pageContext.company_label);
        return;
      }
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "新 增",
            platform_type: pageContext.searchArgs.platform_type,
            company_id: pageContext.searchArgs.company_id,
          },
        },
        area: ["500px", "450px"],
        title: "新增大区",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        },
      });
    },
    handleEdit(record) {
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "保 存",
            itemData: record,
          },
        },
        area: ["500px", "450px"],
        title: "修改大区",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        },
      });
    },
    async handleSetStatus(record, status) {
      pageContext.$http
        .post("/area/setStatus", {
          id: record.id,
          status: status,
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$message.success(response.data.msg);
            pageContext.refreshDataList();
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    handleAddSub(record) {
      pageContext.$layer.iframe({
        content: {
          content: updatePanel,
          parent: this,
          data: {
            submitBtnLabel: "添 加",
            pItemData: record,
          },
        },
        area: ["500px", "550px"],
        title: "添加下级大区",
        shadeClose: false,
        cancel: () => {
          // pageContext.$message.info("操作取消！");
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-circle {
    margin: 0px 5px;
  }
}
</style>
